<!-- Main Container Wrapper -->
<div class="p-3 rounded-4 border shadow-sm bg-body-tertiary">

  <!-- Header Toolbar Context -->
  @if (isHeaderAccess) {
  <div class="row g-3 align-items-end mb-2">

    <!-- Search Box -->
    <div class="col-12 col-md-4 col-xl-3">
      <label class="form-label text-body-secondary font-xs fw-bold text-uppercase tracking-wider mb-1.5">Search User By
        Phone</label>
      <div class="input-group shadow-sm rounded">
        <span class="input-group-text border bg-body text-body-secondary font-xs"><i class="bi bi-telephone"></i></span>
        <input type="text" name="phone" [(ngModel)]="phone"
          class="form-control form-control-sm text-body font-xs border-start-0 ps-0"
          placeholder="Enter phone number..." />
        <button type="submit" class="btn btn-sm btn-primary px-3" (click)="SearchPhone(phone)">
          <i class="bi bi-search font-xs"></i>
        </button>
      </div>
    </div>

    <!-- NRC Filter Box -->
    <div class="col-12 col-md-4 col-xl-3">
      <label class="form-label text-body-secondary font-xs fw-bold text-uppercase tracking-wider mb-1.5">Check NRC
        Status</label>
      <div class="input-group shadow-sm rounded">
        <span class="input-group-text border bg-body text-body-secondary font-xs"><i
            class="bi bi-patch-check"></i></span>
        <select name="filter" [(ngModel)]="nrcStatus"
          class="form-select form-select-sm text-body font-xs border-start-0 ps-0">
          <option value="" disabled selected>Choose status...</option>
          @for (option of filterNRCStatus; track option) {
          <option [value]="option">{{ option }}</option>
          }
        </select>
        <button type="button" class="btn btn-sm btn-primary px-3" (click)="filterButton()">
          <i class="bi bi-funnel-fill font-xs"></i>
        </button>
      </div>
    </div>

    <!-- Action Buttons Group -->
    <div class="col-12 col-md-4 col-xl-6 d-flex flex-wrap gap-2 justify-content-md-end mt-auto">
      <button type="button"
        class="btn btn-sm btn-outline-primary fw-semibold shadow-sm d-inline-flex align-items-center gap-1.5"
        (click)="UpdateRedeemLimitStatusForAllCustomer()">
        <i class="bi bi-arrow-repeat"></i> Update Daily Limits
      </button>
      <button type="button"
        class="btn btn-sm btn-outline-secondary fw-semibold shadow-sm d-inline-flex align-items-center gap-1.5 text-body"
        (click)="goToCustomerUnVerifyList()">
        <i class="bi bi-person-x text-body"></i> UnVerified List
      </button>
    </div>

  </div>
  }

</div>

<!-- Modern Dynamic Table Area -->
<div class="table-responsive mt-3 rounded-4 border shadow-sm bg-body">
  <!-- Removed .text-nowrap from the table so it stays inside your fixed layout dimensions -->
  <table class="table table-hover align-middle mb-0 table-dense">
    <thead class="table-light text-body-secondary font-monospace small text-uppercase tracking-wider border-bottom">
      <tr>
        <!-- Fixed column width allocations to enforce precise sizing targets -->
        <th scope="col" class="ps-3" style="width: 6%;">No</th>
        <th scope="col" style="width: 12%;">Phone</th>
        <th scope="col" style="width: 13%;">Name</th>
        <th scope="col" style="width: 16%;">Email</th>
        <th scope="col" class="text-end" style="width: 10%;">Current</th>
        <th scope="col" class="text-end" style="width: 9%;">Total</th>
        <th scope="col" class="text-end" style="width: 9%;">Daily</th>
        <th scope="col" style="width: 12%;">NRC Verified</th>
        <th scope="col" class="text-center" style="width: 8%;">Status</th>
        <th scope="col" class="pe-4 text-end font-monospace" style="width: 15%;">Actions
        </th>
      </tr>
    </thead>
    <tbody class="font-xs text-body">
      @for (user of customerlist() | paginate : { itemsPerPage: pageSize(), currentPage: page(), totalItems:
      allTotal() };
      track $index) {
      <tr class="transition-base">
        <td class="ps-3 text-body-secondary font-monospace fw-medium">{{ user.srNo }}</td>
        <td class="fw-semibold text-body font-monospace text-nowrap">{{ user.loginPhone }}</td>

        <!-- Truncates long customer names and emails cleanly to maintain the table sizing grid -->
        <td class="fw-bold text-truncate" [title]="user.name">{{ user.name | titlecase }}</td>
        <td class="text-body-secondary text-truncate" [title]="user.email">{{ user.email || '-' }}</td>

        <td class="text-end fw-bold text-success-emphasis font-monospace">{{ user.currentPoints | number }}</td>
        <td class="text-end text-body-secondary font-monospace">{{ user.totalPoints | number }}</td>
        <td class="text-end text-body-secondary font-monospace">{{ user.dailyRedeemableLimit | number }}</td>

        <td class="text-truncate" [title]="user.nrcVerifiedBy">
          @if (user.nrcVerifiedBy) {
          <span class="text-body"><i class="bi bi-person-badge me-1.5 text-body-secondary"></i>{{ user.nrcVerifiedBy
            }}</span>
          } @else {
          <span class="text-body-secondary fst-italic">Pending</span>
          }
        </td>

        <td class="text-center">
          @if (user.enabled == false) {
          <span
            class="badge bg-danger-subtle text-danger-emphasis border border-danger-subtle px-2 py-1 rounded-pill">Disabled</span>
          } @else {
          <span
            class="badge bg-success-subtle text-success-emphasis border border-success-subtle px-2 py-1 rounded-pill">Active</span>
          }
        </td>

        <td class="pe-4 text-end">
          <div class="d-inline-flex align-items-center justify-content-end gap-2 w-100">

            <!-- Status Alert Vector Triggers -->
            <div class="d-inline-flex align-items-center gap-1">
              @if (user.nrcVerifiedBy) {
              <span class="text-success cursor-pointer lh-1" title="Verified" data-bs-toggle="modal"
                data-bs-target="#verifyAlert">
                <i class="bi bi-patch-check-fill fs-6"></i>
              </span>
              }
              @if (!user.nrcFrontImage || !user.nrcBackImage) {
              <span class="text-danger cursor-pointer lh-1" title="No Nrc Image" data-bs-toggle="modal"
                data-bs-target="#imageAlert">
                <i class="bi bi-image-alt fs-6"></i>
              </span>
              }
              @if (!user.nrcVerifiedBy && user.nrcBackImage && user.nrcFrontImage) {
              <span class="text-warning cursor-pointer lh-1" title="Need to verify"
                (click)="goToProfile(user.loginPhone)">
                <i class="bi bi-exclamation-triangle-fill fs-6"></i>
              </span>
              }
            </div>

            <!-- Profile Quick Control Group Tools (Icon-only compact) -->
            <div class="btn-group btn-group-sm border bg-body p-0.5 shadow-sm rounded" role="group"
              aria-label="Profile Actions">

              <!-- View Profile Action -->
              <button type="button"
                class="btn btn-ghost-dark rounded border-0 d-inline-flex align-items-center justify-content-center transition-base"
                style="width: 28px; height: 26px;" title="View Profile" (click)="goToProfile(user.loginPhone)">
                <i class="bi bi-person-fill"></i>
              </button>

              <!-- QR Code History Action -->
              <button type="button"
                class="btn btn-ghost-dark rounded border-0 d-inline-flex align-items-center justify-content-center transition-base"
                style="width: 28px; height: 26px;" title="QR Code History" (click)="goToQrHistory(user.loginPhone)">
                <i class="bi bi-qr-code"></i>
              </button>

              <!-- Exchange List Action -->
              <button type="button"
                class="btn btn-ghost-dark rounded border-0 d-inline-flex align-items-center justify-content-center transition-base"
                style="width: 28px; height: 26px;" title="Exchange List" (click)="goToCustomerRedeem(user.loginPhone)">
                <i class="bi bi-list-check"></i>
              </button>

            </div>

          </div>
        </td>

      </tr>
      } @empty {
      <tr>
        <td colspan="10" class="text-center py-5 text-body-secondary">
          <i class="bi bi-inbox fs-2 d-block mb-2 opacity-50 text-body-secondary"></i>
          No records matched your parameters.
        </td>
      </tr>
      }
    </tbody>
  </table>
</div>

<!-- Custom styled Pagination Layout Element -->
<div class="d-flex justify-content-center mt-3">
  <pagination-controls [maxSize]="10" previousLabel="&laquo;" nextLabel="&raquo;" [responsive]="true"
    class="dashboard-pagination" (pageChange)="handlePageChange($event)">
  </pagination-controls>
</div>


<!-- Floating Mini Card Indicator -->
@if (loading()) {
<div
  class="position-fixed bottom-0 end-0 m-2 z-3 p-3 bg-body card border-info border-opacity-25 shadow-sm d-flex flex-row align-items-center gap-2"
  style="backdrop-filter: blur(4px);">
  <!-- Mini Spinner -->
  <div class="spinner-border text-info" style="width: 1rem; height: 1rem; border-width: 2px;" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>

  <!-- Text Badge Layout (Uses your global micro utilities) -->
  <div class="font-monospace text-info fw-bold tracking-widest text-uppercase pe-1 font-xs">
    Loading...
  </div>
</div>
}

<!-- Modal Verification Wrapper Details -->
<div class="modal fade" id="verifyAlert" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-sm">
    <div class="modal-content border-0 shadow bg-body">

      <!-- Modal Header -->
      <div
        class="modal-header bg-success-subtle text-success-emphasis border-bottom border-success border-opacity-10 py-2.5">
        <h6 class="modal-title font-xs m-0 fw-bold d-flex align-items-center">
          <i class="bi bi-patch-check me-2"></i>System Status
        </h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body text-center py-3 text-body-secondary font-xs">
        This target user portfolio balance structure has already been confirmed.
      </div>

    </div>
  </div>
</div>

<!-- Modal Profile Missing Documentation -->
<div class="modal fade" id="imageAlert" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-sm">
    <div class="modal-content border-0 shadow bg-body">

      <!-- Modal Header -->
      <div
        class="modal-header bg-danger-subtle text-danger-emphasis border-bottom border-danger border-opacity-10 py-2.5">
        <h6 class="modal-title font-xs m-0 fw-bold d-flex align-items-center">
          <i class="bi bi-exclamation-circle me-2"></i>Verification Alert
        </h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body text-center py-3 text-body-secondary font-xs">
        The mandatory front or back digital NRC documentation credentials are not present.
      </div>

    </div>
  </div>
</div>